module.exports = __webpack_public_path__ + "img/argendata.a0250b4e.jpg";